import { Button, Flex, useColorModeValue } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';
import React from 'react';

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
    <path
      d="M10.959 5.92969C13.359 6.13635 14.339 7.36969 14.339 10.0697V10.1564C14.339 13.1364 13.1457 14.3297 10.1657 14.3297H5.82568C2.84568 14.3297 1.65234 13.1364 1.65234 10.1564V10.0697C1.65234 7.38969 2.61901 6.15635 4.97901 5.93635"
      stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
    />
    <path d="M8 1.33594V9.9226" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.2323 8.42969L7.99896 10.663L5.76562 8.42969" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ExportButton = ({ children, ...props }: ButtonProps) => {
  const borderColor = useColorModeValue('#E9ECEF', '#222222');
  const color = useColorModeValue('#616161', '#FFFFFF');
  const hoverBg = useColorModeValue('rgba(0,0,0,0.04)', 'rgba(255,255,255,0.06)');
  const hoverBorderColor = useColorModeValue('#CCCCCC', '#444444');
  const activeBg = useColorModeValue('rgba(0,0,0,0.08)', 'rgba(255,255,255,0.10)');

  return (
    <Button
      type="button"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      whiteSpace="nowrap"
      borderRadius="4px"
      border="1px solid"
      borderColor={ borderColor }
      bg="transparent"
      color={ color }
      fontSize="12px"
      fontWeight={ 500 }
      lineHeight="20px"
      letterSpacing="normal"
      gap="4px"
      sx={{
        height: '32px !important',
        minHeight: '32px !important',
        lineHeight: '20px !important',
      }}
      _hover={{
        bg: hoverBg,
        borderColor: hoverBorderColor,
        color: color,
      }}
      _active={{
        bg: activeBg,
        borderColor: hoverBorderColor,
        color: color,
      }}
      _focusVisible={{
        boxShadow: 'none',
      }}
      px="8px"
      py={ 0 }
      h="32px"
      minH="32px"
      minW="auto"
      flexShrink={ 0 }
      { ...props }
    >
      <Flex alignItems="center" gap="4px">
        <DownloadIcon/>
        { children }
      </Flex>
    </Button>
  );
};

export default React.memo(ExportButton);
